export default {
  PAGE_LIMIT: 30,
}
